var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDescriptionOff = function SvgDescriptionOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45 12.146v-4h-3.024l2.868-2.869-2.121-2.121-4.989 4.99H3v4h30.734l-5.237 5.236H3v4h21.497l-5.236 5.236H3v4h12.26l-5.236 5.237H3v4h3.024l-2.868 2.868 2.121 2.121 4.989-4.989H38v-4H14.266l5.237-5.237H45v-4H23.503l5.236-5.236H38v-4h-5.261l5.237-5.236z"
  })))));
};
export default SvgDescriptionOff;